import { createRouter, RouterProvider } from "@tanstack/solid-router";
import { render } from "solid-js/web";

import { DefaultCatchBoundary } from "@/components/base/default-catch-boundary";
import { NotFound } from "@/components/base/not-found";

import { Spinner } from "./components/base/spinner";
import { routeTree } from "./routeTree.gen";

const router = createRouter({
	routeTree,
	defaultErrorComponent: (props) => <DefaultCatchBoundary {...props} />,
	defaultNotFoundComponent: () => <NotFound />,
	defaultPendingComponent: () => (
		<div class="fixed inset-0 z-3 flex flex-col items-center justify-center gap-4 bg-bg p-6 text-center text-deep-blue @md:gap-8">
			<p class="flex items-center gap-2 text-base">
				<Spinner size={16} />

				<span>Loading...</span>
			</p>
		</div>
	),
	defaultStaleTime: 0,
	defaultPreloadStaleTime: 1000 * 30,
	defaultGcTime: 1000 * 60,
	defaultPendingMs: 1000,
	defaultPendingMinMs: 0,
});

declare module "@tanstack/solid-router" {
	interface Register {
		router: typeof router;
	}
}

const root = document.querySelector("#root");
if (!root) {
	throw new Error("Root element not found");
}

render(() => <RouterProvider router={router} />, root);
